<div class="tw:text-[10px] tw:inline-flex tw:items-center tw:bg-primary-50 tw:rounded-full tw:text-primary-500 tw:px-2 tw:py-[1px]" [class.tw:!py-0]="size === 'sm'">
    <div class="tw:inline-block tw:max-w-[100px] tw:truncate">{{ name }}</div>
</div>